import {bindable} from "aurelia-framework";

export class ParticipantItemsSum {
    @bindable participant;
}
